/**
 * Capa de tracking lista para Analytics / Google Ads / Meta Pixel / CRM.
 * Si las plataformas no están inyectadas, los eventos quedan en la cola local
 * para que el equipo de marketing pueda verificarlos antes del go-live.
 */

type EventPayload = Record<string, string | number | boolean | undefined>

declare global {
  interface Window {
    dataLayer?: unknown[]
    fbq?: (...args: unknown[]) => void
    gtag?: (...args: unknown[]) => void
    __rabemarEvents?: { event: string; payload: EventPayload; at: string }[]
  }
}

export function trackEvent(event: string, payload: EventPayload = {}) {
  const enriched: EventPayload = {
    ...payload,
    page_path: typeof window !== 'undefined' ? window.location.pathname : undefined,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
  }

  if (typeof window === 'undefined') return

  window.__rabemarEvents = window.__rabemarEvents ?? []
  window.__rabemarEvents.push({ event, payload: enriched, at: new Date().toISOString() })

  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push({ event, ...enriched })

  window.gtag?.('event', event, enriched)
  window.fbq?.('trackCustom', event, enriched)
}

export function trackCta(label: string, location: string) {
  trackEvent('cta_click', { cta_label: label, cta_location: location })
}

/** Origen de la oportunidad comercial: página, campaña y referrer. */
export function getLeadSource() {
  if (typeof window === 'undefined') {
    return { page: '', referrer: '', campaign: '', source: '', medium: '' }
  }
  const params = new URLSearchParams(window.location.search)
  return {
    page: window.location.pathname,
    referrer: document.referrer || 'directo',
    campaign: params.get('utm_campaign') ?? '',
    source: params.get('utm_source') ?? '',
    medium: params.get('utm_medium') ?? '',
  }
}
